import WebViewer from '@pdftron/webviewer';
import store from '../../configureStore';
import React, { useRef, useEffect } from 'react';
import { pdfMode, saveButtonMode } from '../../types/enums';
import { OpenFileInfo } from '../../types/types';
import CircularProgress from '@mui/material/CircularProgress';
import { ImportFile } from '../../actions/folderViewActions';
import { dispatch } from '../../actions/actionsBase';

interface PdfTronProps 
{
    PdfFile: OpenFileInfo,
    ClientSide: boolean,
    mode: pdfMode,
    handleClosePdfViewer: () => void;
  }

export const PDFTron = (props: PdfTronProps) => {

    const [isLoading, setIsLoading] = React.useState<boolean>(true);

    const saveBtnMode = store.getState().uiItems.pdfViewerSaveButtonMode;
    const saveBtnTitle = saveBtnMode === saveButtonMode.save ? "Save document" : "Save as attachment";
    const saveBtnId = saveBtnMode === saveButtonMode.save ? "saveCustomButton" : "saveAsAttCustomButton";

    const viewer = useRef(null);
  
    const saveButtonClick = async(blob:Blob,PdfFile: OpenFileInfo) => {

        dispatch(ImportFile(blob, PdfFile))
        setIsLoading(false);
    }

    const closeButtonClick = async() => {
        props.handleClosePdfViewer()
    }

    useEffect(() => {

      WebViewer.WebComponent({
        path: 'webviewer',
        forceClientSideInit: props.ClientSide,
        fullAPI: true,
        css: '/pdfTronCustom.css',
        webviewerServerURL: `${store.getState().appSettings.webViewerServer}`,
        licenseKey: store.getState().appSettings.pdfTronLic,
        disabledElements: ['downloadButton', 'printButton', 'thumbnailControl', 'documentControl','menuButton','insertPage','replacePage','extractPage','signaturePanel','fileAttachmentPanel'],
        disableVirtualDisplayMode: true,
      }, viewer.current!)
        .then(instance => {

                      
            const { UI, Core } = instance;

            const { documentViewer, annotationManager} = Core;
            const userId = store.getState().oidc?.profile.sub! ;
            // console.log(store.getState().oidc?.profile)
            annotationManager.setCurrentUser(userId);
            
            UI.closeElements(['menuOverlay']);
            UI.disableElements(['downloadButton', 'printButton', 'thumbnailControl', 'documentControl','menuButton','insertPage','replacePage','extractPage','signaturePanel','fileAttachmentPanel']);

            let xfdf = "";

            documentViewer.addEventListener('pageComplete', async (pageNumber) => {
                console.log('pageComplete')
                const doc = documentViewer.getDocument();
                if(pageNumber===doc.getPageCount())
                {
                    console.log('Last page rendered')
                    console.log("zoom level after Last page rendered",instance.UI.getZoomLevel()); 
                    
                    //portfolio check
                    const doc = documentViewer.getDocument();
                    const pdfDoc = await doc.getPDFDoc();
                    const root = await pdfDoc.getRoot();
                    if (root) {
                        const collection = await root.findObj('Collection');
                        const isPortfolio = collection !== null;
                        if(isPortfolio)
                        {
                            console.log(`Is portfolio: ${isPortfolio}, enable features`);
                            //enable portfolio files
                            UI.enableFeatures([UI.Feature.Portfolio]);
                            //open left pane and close at the end, leave notes open
                            UI.openElements(['leftPanel']);
                            UI.enableFeatures(['MultiTab']);
                        }
                    }
                }
            });

            documentViewer.addEventListener('documentLoaded', async () => {
                console.log('documentLoaded') 
                // instance.UI.setZoomLevel('150%');
                console.log("zoom level after documentLoaded",instance.UI.getZoomLevel());  
            });

           documentViewer.addEventListener('annotationsLoaded', async () => {
                    console.log('annotationsLoaded')  
                    xfdf = await annotationManager.exportAnnotations();
                    console.log("zoom level after annotationsLoaded",instance.UI.getZoomLevel());  
                    setIsLoading(false);
                });
            
            const modal = {
                dataElement: 'meanwhileInFinlandModal',
                header: {
                  //title: 'Confirm',
                  title: 'Document has been changed and not saved, are you sure you want to exit without saving?',
                  className: 'myCustomModal-header',
                  style: {}, // optional inline styles
                  children: []
                },
                body: {
                  className: 'myCustomModal-body',
                  style: {}, // optional inline styles
                  children: [], // HTML dom elements
                },
                footer: {
                  className: 'myCustomModal-footer footer',
                  style: {}, // optional inline styles
                  children: [
                    {
                      title: 'Cancel',
                      button: true,
                      style: {},
                      className: 'modal-button cancel-form-field-button',
                      onClick: (e:any) => 
                            { 
                                UI.closeElements([modal.dataElement]);
                            }
                    },
                    {
                      title: 'OK',
                      button: true,
                      style: {},
                      className: 'modal-button confirm ok-btn',
                      onClick: (e:any) => { console.log('OK'); closeButtonClick(); }
                    },
                  ]
                },
                render: () => {
                    // besides passing a "render" method, you can use header, body, footer elements
                    // see API doc for more information
                    const customUI = 'Are you sure you want to close without saving?';
                    return customUI;
                  }
              };
            instance.UI.addCustomModal(modal);

                        

            // instance.UI.setFitMode(UI.FitMode.FitWidth);

            console.log("zoom level",instance.UI.getZoomLevel());
            

            // UI.openElements(['leftPanel', 'notesPanel']);
            

  
            const closeCustomButton = new instance.UI.Components.CustomButton({
                title: 'Close window',
                dataElement: 'closeCustomButton',
                img: 'icon-close',
                onClick: async () => {
                    console.log("onClose");
                    try
                    {
                        const doc = documentViewer.getDocument();
                        const pdfDoc = await doc.getPDFDoc();
                        const xfdfString = await annotationManager.exportAnnotations(); 
                        const isModified = await pdfDoc.isModified();
                        
                        const annotationsChanged = xfdfString !== xfdf;
                        if (isModified || annotationsChanged) 
                        {
                            console.log('The PDF has been modified.',isModified);
                            console.log('Annotations has been added.',annotationsChanged);
                            UI.openElements([modal.dataElement]);
                        } 
                        else 
                        {
                            console.log('The PDF has not been modified.');
                            await closeButtonClick();
                        }
                    }
                    catch(error)
                    {
                        console.log("Error",error)
                        await closeButtonClick();
                    }
                }
              }); 

            const header = UI.getModularHeader('default-top-header');

            if (props.mode === pdfMode.edit) {

                UI.disableElements(['toolbarGroup-FillAndSign', 'toolbarGroup-Forms', 'toolbarGroup-Edit']);

                const saveCustomButton = new instance.UI.Components.CustomButton({
                    // type: 'actionButton',
                    // title: 'Save document',
                    // dataElement: 'saveCustomButton',
                    title: saveBtnTitle,
                    dataElement: saveBtnId,
                    img: 'icon-save',
                    onClick: async () => {
                        console.log("onClick");
                        setIsLoading(true);                
                        try
                        {
                            const doc = documentViewer.getDocument();
                            const pdfDoc = await doc.getPDFDoc();
                            const xfdfString = await annotationManager.exportAnnotations(); 
                            const isModified = await pdfDoc.isModified();
                            
                            const annotationsChanged = xfdfString !== xfdf;
                            if (isModified || annotationsChanged) 
                            {
                                console.log('The PDF has been modified.',isModified);
                                console.log('Annotations has been added.',annotationsChanged);
                                let xfdfString = "";
                                if(annotationsChanged)
                                {
                                    xfdfString = await annotationManager.exportAnnotations(); 
                                }
                                const data = await doc.getFileData({xfdfString});
                                const arr = new Uint8Array(data);
                                const blob = new Blob([arr], { type: 'application/pdf' });
                                await saveButtonClick(blob, props.PdfFile);
                            } 
                            else 
                            {
                                setIsLoading(false);
                                console.log('The PDF has not been modified.');
                                UI.displayErrorMessage('The PDF has not been modified.')
                            }
                        }
                        catch(error)
                        {
                            console.log("Error",error)
                            UI.displayErrorMessage("error")
                        }
                    }
                  });

                header.setItems([...header.getItems(), saveCustomButton, closeCustomButton]);
            }
            else
            {
                annotationManager.enableReadOnlyMode();
                header.setItems([...header.getItems(), closeCustomButton]);
            }
           
            UI.loadDocument(props.PdfFile.FilePath, {
                filename: props.PdfFile.File.Name,
                customHeaders: { Authorization: `Bearer ${store.getState().oidc?.access_token}` }
            });

            //close to avoid displacment of the cursor
            //UI.closeElements(['leftPanel']);

            // //add as active tab
            // UI.addEventListener(UI.Events.TAB_MANAGER_READY, async () => {
            //     await UI.TabManager.addTab(props.PdfFile.FilePath, { setActive: true });
            //     });
            // UI.enableFeatures(['MultiTab']);

        })
    }, []);
  
    console.log("render pdfTron");

    const classN = isLoading ? "not-visible" : "App";
    // console.log("classN",classN);
    return (
      <div className={classN}>       
          <div className="webviewer" ref={viewer}></div>
          {isLoading && <div className="material-table-outer-container">
                          <CircularProgress />
                      </div>
          }
      </div>
    );
  };
  